"use strict";

module.exports = {
  CAMPUS_EHS: 'CAMPUS_EHS',
  MEDICAL_CENTER_EHS: 'MEDICAL_CENTER_EHS',
  RISK_SERVICE: 'RISK_SERVICE'
};